<mat-tab-group
  mat-align-tabs="start"
  [selectedIndex]="selectedIndex"
  (selectedIndexChange)="selectedIndexChange($event)">
  <mat-tab>
    <ng-template matTabLabel>
      <span translate="menu/admin/users"></span>
    </ng-template>
    <ng-template matTabContent>
      <app-users
        [loading]="loading"
        [users]="filteredUsers"
        [routingTagExists]="routingTagExists"
        [dropdownItems]="dropdownItems"
        [filtersFormGroup]="filtersFormGroup"
        (userSelected)="onUserClick($event)"
        (teamSelected)="onTeamClick($event)"
        (roleSelected)="onRoleClick($event)"></app-users>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="routingTagExists">
    <ng-template matTabLabel>
      <span translate="users_roles/teams"></span>
    </ng-template>
    <ng-template matTabContent>
      <app-teams
        [loading]="loading"
        [teams]="allTeams"
        (replaceTeam)="replaceTeam($event)"
        (teamSelected)="onTeamClick($event)"
        (enableTeamsSave)="enableTeamsSave()"></app-teams>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel>
      <span translate="users_roles/roles"></span>
    </ng-template>
    <ng-template matTabContent>
      <app-roles
        [loading]="loading"
        [roles]="roles"
        (deleteRole)="deleteRole($event)"
        (roleSelected)="onRoleClick($event)"></app-roles>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<ng-template #userCreateTemplateRef>
  <form [formGroup]="userCreateForm" class="user-create-form">
    <p>
      <mat-form-field>
        <mat-label translate="common/name"></mat-label>
        <input matInput formControlName="name" type="text" [maxlength]="userCreateNameMaxLenth" #userCreateName />
        <mat-hint align="end">{{ userCreateName.value.length }} / {{ userCreateNameMaxLenth }}</mat-hint>
        <mat-error
          *ngIf="userCreateForm.controls.name.errors?.required"
          translate="common/form_errors/required"></mat-error>
      </mat-form-field>
    </p>
    <p>
      <mat-form-field>
        <mat-label translate="email"></mat-label>
        <input matInput formControlName="email" type="email" />
        <mat-error translate="common/form_errors/required"></mat-error>
      </mat-form-field>
    </p>
  </form>
</ng-template>

<ng-template #roleCreateTemplateRef>
  <form [formGroup]="roleCreateForm">
    <p>
      <mat-form-field>
        <mat-label translate="common/name"></mat-label>
        <input matInput formControlName="name" type="text" />
        <mat-error translate="common/form_errors/required"></mat-error>
      </mat-form-field>
    </p>
  </form>
</ng-template>

<ng-template #teamCreateTemplateRef>
  <form [formGroup]="teamCreateForm">
    <p>
      <mat-form-field>
        <mat-label translate="common/name"></mat-label>
        <input matInput formControlName="name" type="text" />
        <mat-error translate="common/form_errors/required"></mat-error>
      </mat-form-field>
    </p>
    <app-business-hours [businessHoursCreateForm]="$any(teamCreateForm.get('businessHours'))"></app-business-hours>
  </form>
</ng-template>

<ng-template #teamReplaceTemplateRef>
  <app-select [control]="replaceTeamControl" [items]="availableTeams" [labelKey]="replaceTeamLabel"></app-select>
</ng-template>
